import { useState, useContext, useCallback } from "react";
import { GlobalContext } from "../../Context/GlobalContext";

const useDelivery = () => {
  const { api, userID } = useContext(GlobalContext);

  const [loading, setLoading] = useState(false);
  const [deliveryPersons, setDeliveryPersons] = useState([]);

  const postRequest = useCallback(
    async (endpoint, body) => {
      const response = await api.post(endpoint, body);
      return response?.data;
    },
    [api]
  );

  const getDeliveryPersons = async () => {
    try {
      setLoading(true);

      const data = await postRequest(
        "/User/getDeliveryPersons",
        {
          userid: userID,
        }
      );

      if (data?.responseCode === "00") {
        setDeliveryPersons(data?.response || []);
      } else {
        setDeliveryPersons([]);
      }

      return data;
    } catch (err) {
      console.error(
        "Get Delivery Persons Error:",
        err?.response?.data || err
      );

      setDeliveryPersons([]);
      return null;
    } finally {
      setLoading(false);
    }
  };

  const addDeliveryPerson = async (data) => {
    try {
      setLoading(true);

      return await postRequest(
        "/User/addDeliveryPersons",
        {
          userid: userID,
          contactName: data.name,
          contactNumber: data.mobile,
          location: data.area,
        }
      );
    } catch (err) {
      console.error(
        "Add Error:",
        err?.response?.data || err
      );

      return null;
    } finally {
      setLoading(false);
    }
  };

  const deleteDeliveryPerson = async (id) => {
    try {
      setLoading(true);

      return await postRequest(
        "/Order/deleteDeliveryPerson",
        {
          deliveryPersonId: id,
        }
      );
    } catch (err) {
      console.error(
        "Delete Error:",
        err?.response?.data || err
      );

      return null;
    } finally {
      setLoading(false);
    }
  };

  return {
    deliveryPersons,
    loading,
    getDeliveryPersons,
    addDeliveryPerson,
    deleteDeliveryPerson,
  };
};

export default useDelivery;